// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchBucket_icon__2JAIn","value":"SearchBucket_value__brB2H","margin":"SearchBucket_margin__3eJZx","badge":"SearchBucket_badge__3cSnH"};